import TaxonomyAdminScreen from "../taxonomy/taxonomy-admin-screen.tsx";

export default function NetworksScreen() {
  return <TaxonomyAdminScreen type="networks" title="شبکه‌های پخش" />;
}
